/**
 * Log an error.
 * @param {Error|string} error The error to log.
 * @returns {undefined}
 */
var logErrorEvent = function logErrorEvent(error) {
  if (window.newrelic && typeof window.newrelic.noticeError === "function") {
    window.newrelic.noticeError(error);
  }
  if (window.dtrum && typeof window.dtrum.reportError === "function") {
    window.dtrum.reportError(error);
  }
};
export default logErrorEvent;